import React, { useEffect } from 'react';
import isMobile from 'is-mobile';

import { PAGE_CONFIG } from '@/constants/pageConfig';

/** 手机端电脑端适配 */
const pcMobileConfig = (
  WrappedComponent: React.ComponentType<{
    isMobilePage: boolean;
  }>,
  config?: {
    pcBodyClass?: string;
    mobileBodyClass?: string;
  }
) => {
  const Page: React.FC = () => {
    const isMobilePage = isMobile();

    useEffect(() => {
      const { pcBodyClass, mobileBodyClass } = config || {};
      const domHtml = document.querySelector('html');
      const domBody = document.querySelector('body');
      const domMeta: HTMLMetaElement = document.querySelector('meta[name="viewport"]')!;
      console.log('==>isMobilePage', isMobilePage, domMeta);
      if (isMobilePage) {
        domHtml?.classList.remove(PAGE_CONFIG.pc.htmlClass);
        domHtml?.classList.add(PAGE_CONFIG.mobile.htmlClass);
        domBody?.classList.remove(PAGE_CONFIG.pc.bodyClass);
        domBody?.classList.add(PAGE_CONFIG.mobile.bodyClass);
        domMeta.content = PAGE_CONFIG.mobile.viewportContent;
        if (pcBodyClass && mobileBodyClass) {
          domBody?.classList.remove(pcBodyClass);
          domBody?.classList.add(mobileBodyClass);
        }
      } else {
        domHtml?.classList.remove(PAGE_CONFIG.mobile.htmlClass);
        domHtml?.classList.add(PAGE_CONFIG.pc.htmlClass);
        domBody?.classList.remove(PAGE_CONFIG.mobile.bodyClass);
        domBody?.classList.add(PAGE_CONFIG.pc.bodyClass);
        domMeta.content = PAGE_CONFIG.pc.viewportContent;
        if (pcBodyClass && mobileBodyClass) {
          domBody?.classList.remove(mobileBodyClass);
          domBody?.classList.add(pcBodyClass);
        }
      }
      return () => {
        domBody?.classList.remove(PAGE_CONFIG.mobile.bodyClass);
        domBody?.classList.remove(PAGE_CONFIG.pc.bodyClass);
        domMeta.content = PAGE_CONFIG.pc.viewportContent;
      };
    }, [isMobilePage]);

    return <WrappedComponent isMobilePage={isMobilePage} />;
  };
  return Page;
};

export default pcMobileConfig;
